import {
  FETCH_MESSAGE_SUCCESS,
  FETCH_MESSAGE_FAIL
} from '@actions/types'

const initialState = {
  account_id: null,
  create_date: null,
  display_name: null,
  isLoading: true,
  message: null,
  subject: null
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
  case FETCH_MESSAGE_SUCCESS:
    return {
      ...state,
      ...payload.data,
      isLoading: false
    }
  case FETCH_MESSAGE_FAIL:
    return {
      ...state,
      isLoading: false
    }
  default:
    return state
  }
}

export default reducer

